import { ActivityV1Type } from "../../../types";

const SURVEY_EXCLUDED = new Set<string>([
  "complexity",
  "didactical_material",
  "certificate_ids",
  "badge_id",
]);

const STANDALONE_ONLY = new Set<string>(["stakeholders", "lo_tag", "credits"]);

export const isFieldVisible = (
  field: string,
  type: ActivityV1Type | null,
  isStandalone: boolean,
): boolean => {
  if (type === "DA_SURVEY" && SURVEY_EXCLUDED.has(field)) return false;
  if (STANDALONE_ONLY.has(field) && !isStandalone) return false;
  return true;
};

export const ADDITIONAL_INFO_REQUIRED_FIELDS: string[] = [];
